import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';

@Component({
  selector: 'app-truck-type-input',
  templateUrl: './truck-type-input.component.html',
  styleUrls: ['./truck-type-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: TruckTypeInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: TruckTypeInputComponent,
    },
  ],
})
export class TruckTypeInputComponent {
  @Input()
  title = "Select Truck Type...";

  @Input()
  isDisabled = false;


  @Input()
  truckTypes = ['RAIL', 'SUPER_LINK', 'RIGID_TRUCK', 'SINGLE_TRAILER', 'OWN_WHEELS'];

  public value?: string;
  public localValue?: string;

  constructor() {
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.value;
    }
  }

  onValueChange(val: string) {
    this.value = val;
    this.onChange(this.value);
    this.writeValue(this.value);
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
